import './InspectView.css';
import { useEffect } from 'react';

export function InspectView(props: { inspect: boolean; setInspect: (open: boolean) => void; children: any; topContent?: any }) {
   const { inspect, setInspect, children, topContent } = props;

   useEffect(() => {
      const handleEsc = (e: any) => {
         if (e.key === 'Escape') {
            setInspect(false);
         }
      };
      window.addEventListener('keydown', handleEsc);

      return () => {
         window.removeEventListener('keydown', handleEsc);
      };
   }, []);

   useEffect(() => {
      if (inspect) {
         document.body.classList.add('modal-open');
      } else {
         setTimeout(() => {
            document.body.classList.remove('modal-open');
         }, 200);
      }
   }, [inspect]);

   const handleClick = (e: any) => {
      if (e.target.classList.contains('inspect-view')) {
         setInspect(false);
      }
   };

   return (
      <div
         className={`inspect-view ${inspect ? 'open' : 'closed'}`}
         onClick={handleClick}>
         <div className="top-content flex items-center justify-end gap-4">
            {topContent}
            <div
               className="close-icon"
               onClick={() => setInspect(false)}>
               <img
                  src="/assets/icons/cross-icon.svg"
                  alt="close"
               />
            </div>
         </div>

         <div className="inspect-view-content ">{children}</div>
      </div>
   );
}
